<script setup>
import { onMounted } from 'vue';
import { initCarousels } from 'flowbite';
import { useI18n } from 'vue-i18n';
import CoursesCarouselCard from '@/components/landing/courses/CoursesCarouselCard.vue';
import resolveImgUrl from '@/services/resolveImageUrl';

const { locale } = useI18n();

const lesson1 = resolveImgUrl('lesson_1.png', locale.value);
const lesson2 = resolveImgUrl('lesson_2.png', locale.value);
const lesson3 = resolveImgUrl('lesson_3.png', locale.value);
const lesson4 = resolveImgUrl('lesson_4.png', locale.value);
const lesson5 = resolveImgUrl('lesson_5.png', locale.value);
const lesson6 = resolveImgUrl('lesson_6.png', locale.value);
const lesson7 = resolveImgUrl('lesson_7.png', locale.value);

onMounted(() => {
  initCarousels();
});
</script>

<template>
  <div
    id="default-carousel"
    class="relative max-h-fit max-w-sm md:max-w-lg mx-auto"
    data-carousel="static"
  >
    <!-- Carousel wrapper -->
    <div class="relative overflow-hidden rounded-lg h-96">
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson1"
        :title="$t('landingPage.coursesSection.courses[0].title')"
        :desc="$t('landingPage.coursesSection.courses[0].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson2"
        :title="$t('landingPage.coursesSection.courses[1].title')"
        :desc="$t('landingPage.coursesSection.courses[1].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson3"
        :title="$t('landingPage.coursesSection.courses[2].title')"
        :desc="$t('landingPage.coursesSection.courses[2].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson4"
        :title="$t('landingPage.coursesSection.courses[3].title')"
        :desc="$t('landingPage.coursesSection.courses[3].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson5"
        :title="$t('landingPage.coursesSection.courses[4].title')"
        :desc="$t('landingPage.coursesSection.courses[4].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson6"
        :title="$t('landingPage.coursesSection.courses[5].title')"
        :desc="$t('landingPage.coursesSection.courses[5].desc')"
      />
      <CoursesCarouselCard
        class="hidden duration-700 ease-in-out"
        data-carousel-item
        :img-src="lesson7"
        :title="$t('landingPage.coursesSection.courses[6].title')"
        :desc="$t('landingPage.coursesSection.courses[6].desc')"
      />
    </div>
    <!-- Slider controls -->
    <button
      type="button"
      class="absolute top-0 start-0 -left-4 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      data-carousel-prev
    >
      <span
        class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60"
      >
        <svg
          class="w-10 h-10 text-secondary dark:text-gray-800 rtl:rotate-180"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M5 1 1 5l4 4"
          />
        </svg>
      </span>
    </button>
    <button
      type="button"
      class="absolute top-0 end-0 z-30 -right-4 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      data-carousel-next
    >
      <span
        class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60"
      >
        <svg
          class="w-10 h-10 text-secondary dark:text-gray-800 rtl:rotate-180"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="m1 9 4-4-4-4"
          />
        </svg>
        <span class="sr-only">Next</span>
      </span>
    </button>
  </div>
</template>
